import { inject, Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

type AnchorTarget = '_self' | '_blank' | '_parent' | '_top' | '_unfencedTop';
/**
 * @description
 * Transforms a string containing links in the markdown format into proper html with a proper link.
 *
 * @exemple
 * ```
 * <h3
 *  [innerHTML]="
 *     'I accept the [terms and conditions](http://www.exemple.com/terms) and the [privacy policy](http://www.exemple.com/privacy).'
 *       | markdownLink
 *   "
 * ></h3>
 * ```
 *
 * @param value The string to be parsed
 * @param anchorTarget The target of the link (_blank, _self etc.).
 * @param cssClass The classes of the link.
 *
 */
@Pipe({
  name: 'markdownLink',
  standalone: true,
})
export class MarkdownLinkPipe implements PipeTransform {
  domSanitizer = inject(DomSanitizer);
  transform(
    value: string,
    target: AnchorTarget = '_self',
    cssClass: string = 'rc-link',
  ): unknown {
    const markdownLinkRegex = /\[([^\]]+)\]\(\s*([^)]+?)\s*\)/g;
    const htmlString = value.replace(
      markdownLinkRegex,
      `<a href="$2" class="${cssClass}" rel="noopener" target="${target}">$1</a>`,
    );
    return this.domSanitizer.sanitize(SecurityContext.HTML, htmlString);
  }
}
